import { apiFetch } from '@/plugins/api.js';
import { getRuntimeApiUrl } from '@/plugins/hostAwareConfig.js';
export default {
  async getInvoices(context) {
    let url =
      `${getRuntimeApiUrl()}/api/user/invoices`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getInvoices', responseData);

    context.commit('setInvoices', responseData.invoices);
    context.commit('updateDatetime');
  },

  async getItems(context) {
    let url =
      `${getRuntimeApiUrl()}/api/items`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getItems', responseData);

    context.commit('setItems', responseData.items);
  },

  async getInvoice(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/api/user/invoices/${payload.id}`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getInvoice ' + payload.id, responseData);

    context.commit('setLoadedInvoice', { invoice: responseData.invoice });
    context.commit('updateDatetime');
  },

  async completePayment(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/payments/invoice`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        stripe_id: payload.stripe_id,
        services: payload.services,
        items: payload.items,
        paymethod_id: payload.paymethod_id,
        // Il core completa l'ordine solo se questo pagamento risulta riuscito su Stripe.
        payment_intent: payload.payment_intent
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('completePayment', responseData);

    return responseData.status_desc;
  },

  async newPaymentIntent(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/payments/intent`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        stripe_id: payload.stripe_id,
        services: payload.services,
        items: payload.items,
        paymethod_id: payload.paymethod_id
      })
    });

    const responseData = await response.json();
    // console.log('newPaymentIntent', responseData);

    if (responseData.status_code == '402') {
      // console.log('Gestisco 3D Secure');
      return responseData.payment_intent;
    }
    else if (responseData.status_code == '200') {
      // console.log('Fine della veglia');
      return false;
    }
    // Qualunque altro esito è un pagamento NON avvenuto: prima tornava `false`
    // come il successo e il checkout mostrava «pagamento avvenuto».
    throw new Error(responseData.message || 'Pagamento non riuscito.');

  },
};
